{
  "Accessibility Menu": "アクセシビリティメニュー",
  "Reset settings": "設定をリセット",
  "Close": "閉じる",
  "Content Adjustments": "コンテンツ調整",
  "Adjust Font Size": "フォントサイズを調整",
  "Highlight Title": "タイトルを強調表示",
  "Highlight Links": "リンクを強調表示",
  "Readable Font": "読みやすいフォント",
  "Color Adjustments": "色の調整",
  "Dark Contrast": "ダークコントラスト",
  "Light Contrast": "ライトコントラスト",
  "High Contrast": "高いコントラスト",
  "High Saturation": "彩度が高い",
  "Low Saturation": "彩度が低い",
  "Monochrome": "モノクローム",
  "Contrast": "コントラスト",
  "Invert Colors": "色を反転する",
  "Tools": "ツール",
  "Reading Guide": "読み上げガイド",
  "Stop Animations": "アニメーションを停止",
  "Big Cursor": "大きなカーソル",
  "Increase Font Size": "フォントサイズを大きくする",
  "Decrease Font Size": "フォントサイズを小さくする",
  "Letter Spacing": "文字間隔",
  "Line Height": "行の高さ",
  "Font Weight": "フォントの太さ",
  "Dyslexia Font": "ディスレクシア用フォント",
  "Language": "言語",
  "Open Accessibility Menu": "アクセシビリティメニューを開く",
  "Widget Settings": "ウィジェット設定",
  "Widget Position": "ウィジェットの位置",
  "Top Left": "左上",
  "Top Center": "上中央",
  "Top Right": "右上",
  "Center Left": "中央左",
  "Center Right": "中央右",
  "Bottom Left": "左下",
  "Bottom Center": "下中央",
  "Bottom Right": "右下",
  "Screen Reader": "スクリーンリーダー",
  "Voice Navigation": "音声ナビゲーション",
  "Custom Color": "カスタムカラー",
  "Change the site's colors": "サイトの色を変更する",
  "Backgrounds": "背景",
  "Headings": "見出し",
  "Contents": "コンテンツ",
  "Reset colors": "色をリセット",
  "Image Desaturation": "画像の彩度を下げる",
  "Search languages": "言語を検索",
  "No languages found": "言語が見つかりませんでした",
  "Accessibility Profiles": "アクセシビリティプロファイル",
  "Motor Impaired": "運動機能サポート",
  "Big cursor, voice navigation, and no animations.": "大きなカーソル、音声ナビ、アニメーションなし。",
  "Blind": "視覚障害",
  "Screen reader helpers with higher contrast.": "コントラストを高めたスクリーンリーダー補助。",
  "Color Blind": "色覚サポート",
  "High contrast palette with desaturated media.": "高コントラストのパレットと彩度を抑えたメディア。",
  "Dyslexia": "ディスレクシア",
  "Friendly font, extra spacing, stronger weight.": "読みやすいフォント、広い行間、太めの文字。",
  "Low vision": "弱視",
  "Dark contrast and 130% magnification.": "ダークコントラストと130%ズーム。",
  "Cognitive & Learning": "認知・学習サポート",
  "Highlights key sections and enables voice help.": "重要なセクションを強調し、音声サポートを有効化。",
  "Seizure & Epileptic": "発作・てんかん",
  "Stops animations and desaturates imagery.": "アニメーションを停止し、画像の彩度を下げます。",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "読み上げガイド、強調リンク、穏やかな配色。",
  "Widget Size": "ウィジェットのサイズ",
  "Default": "デフォルト",
  "Medium": "中",
  "Small": "小",
  "Color Blindness": "色覚サポート",
  "Protanopia": "1型2色覚 (赤)",
  "Deuteranopia": "2型2色覚 (緑)",
  "Tritanopia": "3型2色覚 (青)",
  "Achromatopsia": "全色盲",
  "Simulates and assists users with color vision deficiencies.": "色覚異常を持つユーザーの閲覧を支援・シミュレートします。"
}
